// src/utils/theme.ts
import { useTheme } from 'vuetify'

/** Safe anywhere (no Vuetify context needed) */
export function applyBodyDarkClass(enabled: boolean) {
  document.body.classList.toggle('dark-mode', enabled)
}

/** Must be called inside <script setup> (has Vuetify context) */
export function useApplyDarkMode() {
  const theme = useTheme()
  return (enabled: boolean) => {
    applyBodyDarkClass(enabled)
    theme.global.name.value = enabled ? 'dark' : 'light'
  }
}
